import {ActivatedRoute} from "@angular/router";
import {DialogButton, StdDialogComponent} from "../../shared/std-dialog/std-dialog.component";
import {BsModalService} from "ngx-bootstrap/modal";
import {Observable} from "rxjs";
import swal from "sweetalert2";
import {CommonService} from "../../shared/services/common.service";
import {CompanySelectComponent} from "../../shared/company-select/company-select.component";
import {TranslateService} from "@ngx-translate/core";
import {Address} from "../interfaces/common.interface";
import {dateIsInThePast, getDaysLeftUntilDate} from "../../../assets/js/util";

export function isNonNullObject(obj) {
    if (!!obj && obj instanceof Object)
        return true;
    return false
}

export function isNonEmptyArray(obj) {
    if (!!obj && obj instanceof Array && obj.length > 0)
        return true;
    return false
}

export function isNonNullString(val) {
    if (!!val && typeof val === 'string')
        return true;
    return false
}

export function isNonNullNumber(val) {
    if (!!val && typeof val === 'number')
        return true;
    return false
}

export function isNonNull(obj) {
    return !!obj
}

export function hasProperty(obj, property) {
    if (isNonNullObject(obj) && obj[property])
        return true;
    return false
}

export function asDate(value) {
    if (isNonNullString(value))
        return new Date(value);
    return null
}

export function deepCopy(record: any): any {
    return JSON.parse(JSON.stringify(record))
}

export function extractObjectId(target: any): number {
    if (isNonNullObject(target))
        return target.id
    else if (isNonEmptyArray(target))
        return target[0].id
    return null;
}

export function extractId(record: any, target: string): number {
    if (!record)
        return null;
    if (isNonNullObject(record[target]) && isNonNullNumber(record[target]['id']))
        return record[target]['id']
    else if (isNonNullNumber(record[target]))
        return record[target] as number
    else if (isNonEmptyArray(record[target]))
        return record[target][0] as number
    else if (isNonEmptyArray(record))
        return record[0] as number
    else if (isNonNullNumber(record))
        return record as number
    return null;

}

export function companyId(record: any): number {
    // if(!record)
    //     return null;
    // if (isNonNullObject(record['company']) && isNonNullNumber(record['company']['id']))
    //     return record['company']['id']
    // else if (isNonNullNumber(record['company']))
    //     return record['company'] as number
    // else if (isNonEmptyArray(record['company']))
    //     return record['company'][0] as number
    // else if (isNonEmptyArray(record))
    //     return record[0] as number
    // else if (isNonNullNumber(record))
    //     return record as number
    // return null;

    return extractId(record, 'company')
}

export function nanIs0(value: string) {
    return nanIsDefault(value, 0)
}

export function nanIsDefault(value: string, defaultVal: number) {
    let tmp = Number(value)
    return isNaN(tmp) ? defaultVal : tmp;
}

export function roundStd(val: number) {
    return Math.round(val * 100) / 100
    // return round(val, 2)
}

export function round(val: number, digits: number) {
    return parseFloat(val.toFixed(digits))
}

export function lastRouteFragment(route: ActivatedRoute) {
    if (isNonEmptyArray(route.snapshot.url))
        return route.snapshot.url[0].path
    return null
}

export function routeFragmentAtIndex(route: ActivatedRoute, idx: number) {
    if (isNonEmptyArray(route.snapshot.url))
        return route.snapshot.url[idx].path
    return null
}

export function getFormData(data: any, attachments: File[], mailId: string = 'mail'): FormData {
    const attachmentsMap = {}
    if(attachments && attachments.length > 0)
        attachmentsMap[mailId] = attachments
    const formData = getEmailFormData(data, attachmentsMap);
    return formData
}

export function getEmailFormData(data: any, attachments: {[key: string]: File[]}): FormData {
    const formData = new FormData();
    formData.append("request", new Blob([JSON.stringify(data)], {"type": "application/json"}))
    let i = 1;
    Object.entries(attachments).forEach(([id, attachments]) => {
        for (const attachment of attachments) {
            formData.append("files", attachment, `<${id}>${attachment.name}`);
            formData.set("parentId", id);
        }
    });
    return formData
}

export interface DialogOptions {
    size?: 'sm' | 'lg' | 'xl' | '';
    ignoreBackdropClick?: boolean;
    additionalButtons?: DialogButton[];
    showOk?: boolean;
    showCancel?: boolean;
}

export function getDlg(title: string, execute: (component: any) => void, modalService: BsModalService, options: DialogOptions = {}) {
    const {
        size = 'lg',
        ignoreBackdropClick = false,
        additionalButtons = [],
        showOk = true,
        showCancel = true,
    } = options;

    const initialState = {
        title,
        execute,
        additionalButtons,
        showOk,
        showCancel,
    };

    const modalClass = `modal-dialog-centered${size ? ` modal-${size}` : ''}`;

    const modalRef = modalService.show(
        StdDialogComponent,
        {
            ignoreBackdropClick,
            class: modalClass,
            initialState
        }
    );

    modalRef.content.modalRef = modalRef;
    return modalRef;
}

export function toIsoDate(date: Date | string | null): string | null | Date {
    if (date == null)
        return null;
    if (typeof date === 'string') {
        return new Date(date).toISOString().split('T')[0];
    } else {
        return (date as Date)
    }
}

export function toUTCDate(date: Date) {
// Extract the year, month, and day
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth(); // Note: Month is 0-indexed (0 = January)
    const day = date.getUTCDate();
// Create a new date at midnight UTC
    const utcDate = new Date(Date.UTC(year, month, day));
    console.log(utcDate.toISOString()); // Outputs the date in UTC forma
    return utcDate;
}

export function getCompanyDefault(service: CommonService) {
    return (service.currentCompany ? service.currentCompany.id : service.userCompany.id) as unknown as number
}

export function setCompanyDefault(companySelect: CompanySelectComponent, service: CommonService) {
    const id = getCompanyDefault(service)
    companySelect.setAsynchSelection(id)
    return id
}

export function confirm(title: string, question: string, translationService: TranslateService,
                        confirmCall: () => any, exitOnSuccess?: () => void, cancelCall?: () => Observable<any>,
                        msgParams?: any) {
    swal.fire({
        icon: "question",
        titleText: translationService.instant(title),
        text: translationService.instant(question, msgParams),
        showCancelButton: true,
        showConfirmButton: true,
    }).then((onfulfilled) => {
        if (onfulfilled.value) {
            if (exitOnSuccess)
                exitOnSuccess()
            else
                confirmCall()
        } else if (cancelCall)
            cancelCall();
    });
}

export function stripUrl(url: string) {
    const parts = url.split('/');
    parts.pop(); // Remove the last part
    return parts.join('/');
}

export function getDefaultDatePickerCfg() {
    return {
        config: {
            rangeInputFormat: "DD/MM/YYYY",
            dateInputFormat: "DD/MM/YYYY",
            customTodayClass: "custom-today-class",
        },
        maxDate: new Date(),
        minDate: null,
        date: new Date(),
    }
}

export function getGoAddress(goResponse: any) {
    let address;
    if (goResponse.outcome) {
        const data = goResponse.data;
        let dataAddress = data.address
        return toAddress(dataAddress)
    }
    return address;
}

export function toAddress(dataAddress: Address) {
    let address = dataAddress?.address || ''
    if (dataAddress?.zipCode)
        address = `${address} - ${dataAddress.zipCode}`
    if (dataAddress?.city)
        address = `${address} ${dataAddress.city}`
    if (dataAddress?.province)
        address = `${address} (${dataAddress.province})`
    return address;
}

export function getExpiryStatus(expirationDate: Date | number | string, docCount: number = null, missingDocCount: number = null): string {
    if(docCount && missingDocCount && docCount == missingDocCount)
        return "text-danger";
    let expiryDate = expirationDate;
    if(typeof expiryDate === 'string') {
        expiryDate = new Date(expirationDate)
    }
    if (expiryDate != null) {
        const days = getDaysLeftUntilDate(expiryDate);
        if (dateIsInThePast(expiryDate)) {
            return "text-danger";
        }
        if (days <= 3) {
            return "text-danger";
        }
        if (days <= 15) {
            return "text-warning";
        }
        return "text-success";
    }
    return "text-danger";
}
